const MAX_LENGHT = 25;

function trimPartnerName(name) {
  return name.length > MAX_LENGHT
    ? name.slice(0, MAX_LENGHT).concat("...")
    : name;
}

export default trimPartnerName;
